import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';

export default function HarassmentTrainingForm() {
  const [completionDate, setCompletionDate] = useState('');
  const [signature, setSignature] = useState('');

  useEffect(() => {
    // Example: load existing data
    // ...
  }, []);

  const handleSubmit = async () => {
    const formData = { completionDate, signature };

    try {
      // ...
      console.log('Submitting:', formData);
      alert('Harassment Training form submitted (demo).');
    } catch (error) {
      console.error('Submission error:', error);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 2 }}>
      <TextField
        label="Completion Date"
        type="date"
        value={completionDate}
        onChange={(e) => setCompletionDate(e.target.value)}
        fullWidth
        margin="normal"
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        label="Signature"
        value={signature}
        onChange={(e) => setSignature(e.target.value)}
        fullWidth
        margin="normal"
      />

      <Button variant="contained" onClick={handleSubmit} sx={{ mt: 2 }}>
        Save
      </Button>
    </Box>
  );
}